
import {
    ReactElement,
    HTMLAttributes
} from "react";
import { CircleTick } from "../../assets";

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    image?:string;
    myStyle?:string;
    onClick?:any;
    active?:boolean;
    isFaq?:boolean;
    subTitle?:string;
}

export function FaqCard({ title , image , myStyle , onClick , active , isFaq , subTitle}: Props): ReactElement {

    return (
        <div className={`${myStyle && myStyle} ${active ? "faq-card-active" : "" } ${isFaq ? "faq-card-border" : ""} faq-card`} onClick={onClick}>
            {
                active && 
                <img src={CircleTick} className="circle-tick" alt="هامرز"/>
            }
            <img className="faq-card-img" src={image} alt="هامرز" />
            <span className="faq-card-title">
                {title}
            </span>
            {subTitle && 
            <span className="faq-card-title mt-0">
                {subTitle}
            </span>
            }
        </div>
    );
}

export default FaqCard;